export const NOT_AUTHENTICATED = 'NOT_AUTHENTICATED'
export const AUTHENTICATED = 'AUTHENTICATED'
export const NEW_PASSWORD_REQUIRED = 'NEW_PASSWORD_REQUIRED'
export const RESET_PASSWORD_REQUIRED = 'RESET_PASSWORD_REQUIRED'
export const IS_NOT_CONFIRMED = 'IS_NOT_CONFIRMED'
export const EMAIL_VERIFICATION_REQUIRED = 'EMAIL_VERIFICATION_REQUIRED'
